module.exports = __webpack_public_path__ + "img/118320-foto_torre_de_salamanca_5.da598280.jpg";